import { Button, Popover, Text } from "@nike/eds";
import { InfoCircleFilled } from "@nike/nike-design-system-icons";
import { useState } from "react";

export const ContainerNumbersPopover = ({containerNumbers}: {containerNumbers: string[]}) => {
    const [isContainerNbrsPopoverOpen, setIsContainerNbrsPopoverOpen] = useState(false);
    return (
        <Popover
            isOpen={isContainerNbrsPopoverOpen}
            isDark={true}
            placement="right"
            headerSlot={<Text font="body-2" as="div" className=""><strong>Container Numbers</strong></Text>}
            bodySlot={
                <div className="eds-spacing--p-8">
                    {containerNumbers.map((cn, idx) => (
                        <Text key={idx} font="body-1" as="div" color="white">{cn}</Text>
                    ))}
                </div>
            }
        >
            <Button 
              onClick={() => setIsContainerNbrsPopoverOpen(!isContainerNbrsPopoverOpen)}
              size="small"
              style={{ padding: 0, minWidth: 0 }}>
                <InfoCircleFilled style={{ width: "16px", height: "16px" }} />
            </Button>
        </Popover>
    );
}
